import { NotificationTrigger } from '../../enums/notifications';

interface ReportParameters {
  trigger: NotificationTrigger;
  organizationId?: string;
  robotId?: string;
  all?: boolean;
  startTime: string;
  endTime: string;
}

export const convertReportParametersToQuery = (params: ReportParameters): string => {
  const json = JSON.stringify(params);
  return btoa(json); // base64 encode
};

export const convertReportQueryToParameters = (query: string | null): ReportParameters | null => {
  if (query == null) return null;

  try {
    const json = atob(query);
    const obj = JSON.parse(json);

    // Optionally validate required fields
    if (!obj.trigger) return null;

    return obj as ReportParameters;
  } catch {
    return null;
  }
};

export default ReportParameters;
